<style lang="sass">
    .cash-primary-button{
        &.wui-button.is-plain:after{
            border-color: #00c2e0;
        }
    }
</style>

<template>
<w-button 
    class="cash-primary-button"
    @click="handleClick"
    :width="width" 
    :height="height" 
    :plain="plain" 
    :bg-color="opts.bgColor" 
    :sharp="sharp"
    :disabled="disabled"
    :font-color="opts.fontColor">
    <slot></slot>
    </w-button>
</template>

<script>
    import {Button} from 'wui';
    export default {
        name: 'c-primary-button',
        extends: Button,
        methods:{
            handleClick(evt) {
                this.$emit('click', evt);
            }
        },
        computed:{
            opts(){
                return !this.plain ? {
                    bgColor: '#00c2e0',
                    fontColor: '#fff'
                } : {
                    bgColor: '#fff',
                    fontColor: '#00c2e0'
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// primary-button.vue?acacba7c